import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["projectSelect"]

  connect() {
    App.DynamicSelect.initEl(this.projectSelectTarget)
    App.DynamicSelect.onChange(this.projectSelectTarget, this.updateProjectID.bind(this))
    this.projectID = this.projectSelectValue
  }

  submitForm(event) {
    if (this.shouldWarn && !confirm(this.warningMessage)) {
      if (event) {
        event.preventDefault()
        event.stopPropagation()
        event.stopImmediatePropagation()
      }
    }
  }

  updateProjectID() {
    this.shouldWarn = !this.newRecord && !!this.projectID
    this.projectID = this.projectSelectValue
  }

  get projectID() {
    return this.data.get("project-id")
  }

  set projectID(id) {
    this.data.set("project-id", id)
  }

  get projectSelectValue() {
    return App.DynamicSelect.getValue(this.projectSelectTarget)
  }

  get shouldWarn() {
    return App.Helpers.isTruthy(this.data.get("should-warn"))
  }

  set shouldWarn(val) {
    this.data.set("should-warn", val ? "1" : null)
  }

  get newRecord() {
    return App.Helpers.isTruthy(this.data.get("new-record"))
  }

  get warningMessage() {
    return `
WARNING:
Changing the milestone's project will result in all associated time entries being moved to the new project.

Do you want to proceed?
    `
  }
}



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/milestones/milestone-form-controller.js